<script>
export default {
  name: 'TamaraOverlayLoading',
  props: {
    visible: Proptypes.boolean(false),
    fullscreen: Proptypes.boolean(true),
    inline: Proptypes.boolean(false),
    dialog: Proptypes.boolean(false),
    title: Proptypes.string(''),
    subtitle: Proptypes.string(''),
    opacity: Proptypes.string('0.3'),
    hideOverlay: Proptypes.boolean(false),
    absolute: Proptypes.boolean(false),
    rounded: Proptypes.string('12px'),
    persistent: Proptypes.boolean(false),
  },
}
</script>

<template>
  <v-dialog
    v-if="dialog"
    :value="visible"
    :persistent="persistent"
    width="90vw"
    max-width="570px"
    transition="scale-transition"
    v-bind="$attrs"
  >
    <v-card class="px-6 py-7 text-center px-sm-10 py-sm-10">
      <div class="tamara-loading-spinner tamara-loading-spinner--popup">
        <div class="loading-spinner">
          <div class="spinner-ring" />
        </div>
      </div>
      <!-- This is title -->
      <div class="mt-5 tamara-title-2 text-center">
        {{ title }}
      </div>
      <!-- This is subtitle -->
      <div class="tamara-subtitle-1 mt-2 gray--text">
        {{ subtitle }}
      </div>
    </v-card>
  </v-dialog>
  <div v-else-if="inline" class="tamara-loading-spinner">
    <div class="loading-spinner">
      <div class="spinner-ring" />
    </div>
  </div>
  <v-overlay
    v-else-if="fullscreen"
    :value="visible"
    :opacity="opacity"
    :absolute="absolute"
    v-bind="$attrs"
    :style="`border-radius: ${rounded}; max-width: 100vw; max-height: 100vh;`"
  >
    <slot>
      <div class="tamara-loading-spinner">
        <div class="loading-spinner">
          <div class="spinner-ring" />
        </div>
      </div>
    </slot>
  </v-overlay>
</template>

<style lang="scss" scoped>
.tamara-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 60px;

  &--popup {
    min-height: 80px;
  }
}

.loading-spinner {
  width: 30px;
  height: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 4px solid #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-sizing: border-box;
  display: block;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
